import {CHANGE_SLIDER_POSITION, START_SLIDER, STOP_SLIDER} from '../../actions/slider'

const initialState = {
    isLooping: false,
    interval: null,
    position: 0
}

const slider = (state = initialState, action) => {
    switch (action.type) {
        case START_SLIDER:
            return {
                ...state,
                isLooping: true,
                interval: action.interval
            }

        case STOP_SLIDER:
            clearInterval(state.interval)
            return {
                ...state,
                isLooping: false,
                interval: null
            }

        case CHANGE_SLIDER_POSITION:
            return {
                ...state,
                position: action.position
            }
        default:
            return state
    }
}

export default slider



// WEBPACK FOOTER //
// ./src/reducers/map/slider.js